const Table = (theme) => {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[0],
          borderTopColor: theme.palette.divider,
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          textTransform: "none",
          backgroundColor: theme.palette.customColors.tableHeaderBg,
          "& .MuiTableCell-head": {
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.02em",
            color: theme.palette.text.secondary,
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-body": {
            fontSize: "0.875rem",
            letterSpacing: "0.01em",
            color: theme.palette.text.primary,
            "&:not(.MuiTableCell-sizeSmall):not(.MuiTableCell-paddingCheckbox):not(.MuiTableCell-paddingNone)":
              {
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
              },
          },
          "& .MuiTableRow-root:hover": {
            backgroundColor: "rgba(30, 58, 95, 0.04)",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head:first-of-type, & .MuiTableCell-root:first-of-type":
            {
              paddingLeft: theme.spacing(2),
            },
          "& .MuiTableCell-head:last-child, & .MuiTableCell-root:last-child": {
            paddingRight: theme.spacing(2),
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          "& .MuiButton-root": {
            textTransform: "none",
            color: theme.palette.primary.main,
          },
        },
        stickyHeader: {
          backgroundColor: theme.palette.customColors.tableHeaderBg,
        },
      },
    },
  };
};

export default Table;
